import { useEffect } from "react";
import { useCompany } from "../context/CompanyContext";
import axiosInstance from "../utils/axiosInstance";

export const useFetchCompany = () => {
  const { setCompany, setCompanies, setCompaniesLoading } = useCompany();

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axiosInstance.get("/accounts/company-options/", {
          skipCompany: true,
        });
        const companyList = Array.isArray(response.data)
          ? response.data
          : response.data.results || [];
        setCompanies(companyList);

        const storedId = localStorage.getItem("active_company_id");
        const selected =
          companyList.find((item) => String(item.id) === String(storedId)) ||
          companyList[0] ||
          null;
        setCompany(selected);
      } catch (error) {
        console.error("Failed to fetch companies:", error);
      } finally {
        setCompaniesLoading(false);
      }
    };

    fetchCompanies();
    // Context setters are stable for the lifetime of the provider.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
